import { ISpacingProps, MediaMapResult, TBreakpointKeys } from '@belong/types';
import { spacingMixin, COLOURS, mediaMap, shouldForwardProp } from '@belong/themes';
import styled, { css } from 'styled-components';

import { TDensity } from './ActionRowList.types';
import { Container as ReadOnlyRow } from '../../actions/ReadOnlyRow/ReadOnlyRow.styles';
import { Container as ButtonRow } from '../../actions/ButtonRow/ButtonRow.styles';

interface IActionRowSpacedBottom extends ISpacingProps {
  hasDividers: { [k in TBreakpointKeys]?: boolean } | boolean;
  spacing: { [k in TBreakpointKeys]?: TDensity } | TDensity;
  role: string;
}

export const ActionRowSpacedBottom = styled.ul.withConfig({
  shouldForwardProp: shouldForwardProp<IActionRowSpacedBottom>('spacing')
})<IActionRowSpacedBottom>`
  list-style: none;

  ${spacingMixin}
  > ${ReadOnlyRow}, > ${ButtonRow} {
    ${({ spacing }): MediaMapResult => {
      return mediaMap(spacing, (result: TDensity) => {
        switch (result) {
          case 'loose':
            return css`
              padding-top: 2.4rem;
              padding-bottom: 2.4rem;
            `;
          case 'compact':
            return css`
              padding-top: 0.8rem;
              padding-bottom: 0.8rem;
            `;
          case 'none':
            return css`
              padding-top: 0;
              padding-bottom: 0;
            `;
          case 'default':
          default:
            return css`
              padding-top: 1.6rem;
              padding-bottom: 1.6rem;
            `;
        }
      });
    }}

    ${({ hasDividers }) => {
      return mediaMap(
        hasDividers,
        (result: boolean) => css`
          &:not(:last-child) {
            border-bottom: ${result ? `0.1rem solid ${COLOURS.GREY_300}` : 'none'};
          }
        `
      );
    }}
  }
`;
